<template>
    <div>
        <div class="page page1" :class="year == 2023 ? 'page2023' : 'page2024'" :style="{'height': height + 'px'}" v-if="showReport == 1">
            <div class="title">
                <img @click="back" class="back" src="@/assets/report/year2023/back.png">
<!--                <img @click="share" class="share-icon" src="@/assets/report/year2023/share.png">-->
                <img @click="toHistory" class="history-icon" src="@/assets/report/year2023/history.png">
            </div>
            <div class="radio-box">
                <div class="radio">
                    <van-checkbox v-if="year == 2023" v-model="isRadio" icon-size="18px" checked-color="#20D38F"
                                  shape="square"></van-checkbox>
                    <van-checkbox v-if="year == 2024" v-model="isRadio" icon-size="18px" checked-color="#637BFF"
                                  shape="square"></van-checkbox>
                </div>
                <span class="radio-text">我已阅读并同意<span :class="year == 2023 ? 'green' : 'purple'" @click="showPrivacy">隐私声明</span></span>
            </div>
            <div :class="year == 2023 ? 'open-btn2023' : 'open-btn2024'" @click="toOpen()"></div>
        </div>
        <div class="none" v-if="showReport == 0">
            <div class="title-none">
                <img @click="back" class="back" src="@/assets/share/home/back.png">
<!--                <img @click="toHistory" class="history-icon" src="@/assets/report/weekly/history.png">-->
            </div>
            <div class="no-content">
                <img class="no-icon" src="@/assets/report/weekly/no.png">
                <div class="no-time-range">
                    <div v-if="year">{{ year }}年</div>
                    <div>暂无年报</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Dialog, Toast} from 'vant'
    import {getQueryVariable} from '@/utils/comment'

    export default {
        name: 'year',
        data() {
            return {
                showReport: -1,
                height: 800,
                isRadio: true,
                checkbox: 0,
                checked: true,
                year: 2023,
                theme: '',
            }
        },
        mounted() {
            if (this.$route.query.token) {
                localStorage.setItem("token", this.$route.query.token);
            }
            if (this.$route.query.year) {
                this.year = this.$route.query.year;
            } else {
                this.year = new Date().getFullYear() - 1
            }
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme;
            }
            this.getHeight();
            this.checkSportYear();
        },
        methods: {
            checkSportYear() {
                this.$api.report.checkSportYear({
                    year: this.year
                }).then(res => {
                    if (res.info > 0) {
                        this.showReport = 1;
                    } else {
                        this.showReport = 0;
                    }
                })
            },
            back() {
                if (window.history.length == 1) {
                    this.$router.push({
                        name: 'newSportList',
                        query: {
                            lang: this.$i18n.locale,
                            theme: this.theme
                        }
                    })
                } else {
                    this.$router.back();
                }

            },
            share() {
                WebJSBridge.call("shareReport", null, function (res) {
                    console.log("recieve callback")
                    console.log(res)
                });
            },
            toHistory() {
                this.$router.push({
                    name: 'yearHistory',
                    query: {
                        userId: this.userId,
                        year: this.year,
                        theme: this.theme
                    }
                })
            },
            getHeight() {
                this.height = window.innerHeight;
                console.log(this.height)
            },
            toOpen() {
                if (!this.isRadio) {
                    Toast({
                        getContainer: '#app',
                        message: "请先同意隐私声明后\n再开启个人年报",
                    });
                } else {
                    this.$router.push({
                        name: 'year',
                        query: {
                            userId: this.userId,
                            year: this.year,
                            theme: this.theme
                        }
                    })
                }
            },
            showPrivacy() {
                let color = this.year == 2023 ? '#20D38F' : '#637BFF';
                Dialog.confirm({
                    title: '隐私声明',
                    message: '年报需要您授权Astrolink手表APP分析您在使用过程中存储的运动、睡眠、健康等个人历史数据。年报数据计算均使用中国标准时间 （GMT+08:00） ，是否同意并继续生成报告？',
                    getContainer: "#app",
                    confirmButtonColor: color,
                    confirmButtonText: '同意',
                    cancelButtonText: '取消',
                    cancelButtonColor: 'rgb(133 130 130)',
                }).then(() => {
                    this.isRadio = true;
                }).catch(() => {
                    this.isRadio = false;
                });
            }
        }
    }
</script>

<style scoped>

    .page {
        position: relative;
        height: 100%;
        background-color: #6be5b5 !important;
    }

    .back {
        width: 22px;
        height: 22px;
        position: absolute;
        left: 15px;
        top: 55px;
    }

    .share-icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 55px;
        right: 47px;
    }

    .history-icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 55px;
        right: 15px;
    }

    .page2023 {
        background: url("~@/assets/report/year2023/bg1.png");
        background-size: 375px;
        position: relative;
    }

    .page2024 {
        background: url("~@/assets/report/year2024/bg1.png");
        background-size: 375px;
        position: relative;
    }

    .green {
        font-weight: bold;
        color: #2AAF67;
    }

    .purple {
        font-weight: bold;
        color: #637BFF;
    }

    .radio-text {
        font-size: 14px;
        color: #707070;
        vertical-align: center;
        letter-spacing: 1px;
    }

    .open-btn2023 {
        background: url("~@/assets/report/year2023/btnbg1.png");
        background-size: 215px;
        width: 215px;
        height: 68px;
        position: absolute;
        bottom: 20px;
        left: 80px;
    }

    .open-btn2024 {
        background: url("~@/assets/report/year2024/btnbg1.png");
        background-size: 241px;
        width: 241px;
        height: 60px;
        position: absolute;
        bottom: 30px;
        left: 67px;
    }

    /deep/ .van-icon {
        border-radius: 3px;
    }

    .radio {
        display: inline-block;
    }

    .radio-box {
        position: absolute;
        bottom: 110px;
        width: 100%;
        text-align: center;
    }

    .no-content {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .no-icon {
        width: 183px;
        position: absolute;
        top: 55px;
        left: 94px;
    }

    .no-time-range {
        padding-top: 200px;
        text-align: center;
        color: #999999;
        font-size: 15px;
    }

    .no-time-range div {
        margin-bottom: 9px;
    }

    .title-none {
        width: 375px;
        height: 88px;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/views/report/openYear.vue